/**
 * "Was this helpful?" — one tap, sent with the app's activity tracker as
 * `help_article_feedback` so the articles that don't answer the question
 * show up in the data.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { trackEvent } from '@/lib/activityTracker';

export default function ArticleFeedback({ articleId }) {
  const [answer, setAnswer] = useState(null);

  const send = (helpful) => {
    if (answer !== null) return;
    setAnswer(helpful);
    trackEvent('help_article_feedback', { article: articleId, helpful });
  };

  if (answer !== null) {
    return (
      <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-4 text-[14.5px] text-white/80" role="status">
        {answer
          ? 'Thanks for letting us know.'
          : <>Thanks, we’ll use that to improve this article. If you still need help, <Link to="/contact" className="text-[#AAB4D6] underline decoration-white/25 underline-offset-2 hover:text-white">contact us</Link>.</>}
      </div>
    );
  }
  const btn = 'inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-4 py-2 text-[14px] text-white/85 hover:bg-white/[0.08] hover:text-white transition-colors';
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-4">
      <p className="mr-auto text-[14.5px] text-white/85">Was this article helpful?</p>
      <button type="button" className={btn} onClick={() => send(true)}>
        <ThumbsUp className="h-4 w-4" strokeWidth={1.75} /> Yes
      </button>
      <button type="button" className={btn} onClick={() => send(false)}>
        <ThumbsDown className="h-4 w-4" strokeWidth={1.75} /> No
      </button>
    </div>
  );
}
ArticleFeedback.propTypes = { articleId: PropTypes.string.isRequired };
